import { Download, Info, Upload } from 'lucide-react';
import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import RequestSupportMenuItem from '../property-asset-view/assets-action-bar/RequestSupportMenuItem';
import { useStagedActions } from './useStagedActions';
import { useImageDetailsToggle } from '../property-asset-view/assets-action-bar/useImageDetailsToggle';

type StagedMenuItemsProps = {
  setShowDownloadModal: (show: boolean) => void;
  onOpenSupportRequest: () => void;
  onOpenUpload: () => void;
};

// AssetsControlBar's `menu` slot for the Virtual Staging tab (the kebab's
// contents): sub-lg-first Request Support (QA round 3, 2026-08-19), then Show
// Image Details at every width (DV-2856), then the sub-lg-only Download/Upload
// mirrors of StagedLeadingActions's icon buttons (mirrors PhotosMenuItems'
// lg:hidden mirrors).
//
// Keep this list current: it is the only inventory of the menu, and a stale
// one is what the PR #1154 review caught (it still claimed the August kebab).
// Nothing here is a view filter — this tab has no Show Hidden toggle — so the
// selection lock reaches only its search field and the photoset select, both
// of which live in the control row.
const StagedMenuItems = ({
  setShowDownloadModal,
  onOpenSupportRequest,
  onOpenUpload
}: StagedMenuItemsProps) => {
  const { uploadEnabled, hasSelectableStaged, downloadLabel } =
    useStagedActions();
  const { showImageDetails, setShowImageDetails } = useImageDetailsToggle();

  return (
    <>
      <RequestSupportMenuItem onOpenSupportRequest={onOpenSupportRequest} />
      <DropdownMenuSeparator className="lg:hidden" />
      {/* DV-2856: staged photos are real committed Assets with their own Image
          IDs, so the tab gets the same toggle. No lg:hidden — unlike the
          Download/Upload mirrors below, this has no desktop equivalent
          elsewhere in the bar (which is also why the page stopped passing
          menuSubLgOnly for this tab). */}
      <DropdownMenuItem onSelect={() => setShowImageDetails(!showImageDetails)}>
        <Info className="w-4 h-4" />
        {showImageDetails ? 'Hide Image Details' : 'Show Image Details'}
      </DropdownMenuItem>
      <DropdownMenuItem
        className="lg:hidden"
        disabled={!hasSelectableStaged}
        onSelect={() => setShowDownloadModal(true)}
      >
        <Download className="w-4 h-4" />
        {downloadLabel}
      </DropdownMenuItem>
      {uploadEnabled && (
        <DropdownMenuItem className="lg:hidden" onSelect={onOpenUpload}>
          <Upload className="w-4 h-4" />
          Upload Staged Photos
        </DropdownMenuItem>
      )}
    </>
  );
};

export default StagedMenuItems;
